export const VALIDATE_SCHEDULE_OTP_CODE_ENDPOINT = '/booking-portal/OTP/ValidateOTPBookExperience';
